module.exports = __webpack_public_path__ + "static/media/live_costs_dark-01.572ffd21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/live_costs_dark-01.png
// module id = 7019
// module chunks = 0